export const branscher = [
    "Ekonomi och juridik",
    "Hälsa / Vård / Socialt arbete",
    "Ingenjörsvetenskap",
    "IT",
    "Lärarutbildning",
    "Musik / dans och kultur",
    "Naturvetenskap",
    "Samhällsvetenskap och humaniora",
]
export const tjanster = [
    "Anställning",
    "Trainee",
    "Extrajobb",
    "Examensarbete",
    "Sommarjobb",
    "Praktik",
    "Medlemskap",
]
